import React, { useEffect, useState } from 'react';
import { Box, Button, Stack, TextField, Typography, Checkbox, FormControlLabel } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { teamApi } from '../../services/api';


const TeamForm: React.FC = () => {
  const { id } = useParams();
  const isEdit = Boolean(id);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);
  const [form, setForm] = useState({
    name: '',
    long_name: '',
    abbreviation: '',
    color: '',
    is_international: false,
  });

  useEffect(() => {
    if (isEdit && id) {
      setLoading(true);
      teamApi.getById(parseInt(id)).then(res => {
        console.log(res);
        setForm({
          name: res.data.name || '',
          long_name: res.data.long_name || '',
          abbreviation: res.data.abbreviation || '',
          color: res.data.color || '',
          is_international: !!res.data.is_international,
        });
      }).catch(() => setError('Failed to load team')).finally(() => setLoading(false));
    }
  }, [id, isEdit]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, type, checked } = e.target;
    setForm(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setSuccess(null);
    try {
      if (isEdit && id) {
        await teamApi.update(parseInt(id), form);
        setSuccess('Team updated successfully');
      } else {
        await teamApi.create(form);
        setSuccess('Team created successfully');
        setForm({ name: '', long_name: '', abbreviation: '', color: '', is_international: false });
      }
      setTimeout(() => navigate('/football/teams'), 1000);
    } catch (err: any) {
      setError('Failed to save team');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box maxWidth={500} mx="auto" mt={4}>
      <Typography variant="h5" mb={2}>{isEdit ? 'Edit' : 'Create'} Football Team</Typography>
      <form onSubmit={handleSubmit}>
        <Stack spacing={2}>
          <TextField label="Name" name="name" value={form.name} onChange={handleChange} required fullWidth />
          <TextField label="Long Name" name="long_name" value={form.long_name} onChange={handleChange} fullWidth />
          <TextField label="Abbreviation" name="abbreviation" value={form.abbreviation} onChange={handleChange} fullWidth />
          <TextField label="Color" name="color" value={form.color} onChange={handleChange} fullWidth />
          <FormControlLabel control={<Checkbox checked={form.is_international} onChange={handleChange} name="is_international" />} label="International" />
          {error && <Typography color="error">{error}</Typography>}
          {success && <Typography color="success.main">{success}</Typography>}
          <Button type="submit" variant="contained" disabled={loading}>{isEdit ? 'Update' : 'Create'}</Button>
        </Stack>
      </form>
    </Box>
  );
};

export default TeamForm; 